<template>
  <div class="container combination-page">
    <div class="row">
      <div class="loader" v-if="loading">
        <div class="load-spinner"></div>
      </div>

      <div
        class="animated fadeInDown"
        style="padding:15px 0;position:relative;"
      >
        <h3>Update your Course Combination - {{ code || "??" }}</h3>
        <div class="courses">
          <label
            class="course"
            v-for="course in selectCourseCombinationData"
            :key="course.id"
            :for="course.id"
            :class="{
              checked: selectCombination.includes(course.id),
              disabled:
                selectCombination.length > 3 &&
                !selectCombination.includes(course.id)
            }"
          >
            <input
              type="checkbox"
              name="course"
              :value="course.id"
              v-model="selectCombination"
              :id="course.id"
              :disabled="
                selectCombination.length > 3 &&
                  !selectCombination.includes(course.id)
              "
            />
            {{ course.title }}
          </label>
        </div>

        <div>
          <button type="button" @click="updateCombination">Save</button>
          <button class="closeBtn" type="button" @click="$router.go(-1)">
            Back
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseCombination",

  data() {
    return {
      id: null,
      code: "",
      selectCombination: [],
      loading: false
    };
  },

  watch: {
    selectCombination(courses) {
      if (courses.length == 4) {
        const selected = [];
        Object.assign(selected, courses).sort();
        const combination =
          this.$store.state.course.combinations.filter(c => {
            if (JSON.stringify(c.courses) === JSON.stringify(selected)) {
              return true;
            } else {
              return false;
            }
          })[0] || {};
        this.code = combination.code || "";
        this.id = combination.id || null;
      } else {
        this.code = "";
        this.id = null;
      }
    }
  },

  computed: {
    selectCourseCombinationData() {
      return this.$store.getters["course/selectCourseCombinationData"];
    },

    student() {
      return this.$store.state.auth.user;
    }
  },

  async mounted() {
    // this.loading = true;
    if (this.$store.state.course.courses.length < 1) {
      await this.$store.dispatch("course/getCourses");
    }
    if (this.$store.state.course.combinations.length < 1) {
      await this.$store.dispatch("course/getCoursesCombinations");
    }
    if (this.$store.state.student.combination.courses.length < 1) {
      await this.$store.dispatch("student/getCourseCombination");
    }

    this.code = this.$store.state.student.combination.code || "";
    this.selectCombination =
      this.$store.state.student.combination.courses || [];
    this.loading = false;
  },

  methods: {
    updateCombination() {
      if (this.selectCombination.length < 4) {
        this.$store.commit("showAlert", {
          message: "Pleaase select 4 courses including English",
          status: "danger"
        });
        return false;
      }
      this.loading = true;
      this.$store
        .dispatch("student/updateCourseCombination", {
          id: this.id
        })
        .then(response => {
          this.$store.commit("showAlert", {
            message: response.data.message,
            status: "success"
          });
        })
        .catch(error => {
          this.$store.commit("showAlert", {
            message: error.response.data.message || "Failed to load",
            status: "danger"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
